import { NetworkMonitorConfig } from "./networkStatusTypes";

// Universal 0-byte 204 endpoint that requires no authentication and never returns 403
export const getEffectivePingEndpoint = (): string => {
  return "https://www.google.com/generate_204";
};

/**
 * Default Configuration & Threshold Constants for Network Monitoring
 */
export const DEFAULT_NETWORK_MONITOR_CONFIG: NetworkMonitorConfig = {
  // Reliable lightweight endpoint used for active HTTP latency probing
  pingEndpoint: getEffectivePingEndpoint(),
  // Periodic ping evaluation interval (15 seconds with jitter to protect server capacity)
  pingIntervalMs: 15000,
  // Expected standard baseline speed for online test taking (3.5 Mbps)
  // At 3.5 Mbps:
  // - >= 2.45 Mbps (<= 30% reduction): GOOD (Green)
  // - 1.75 - 2.45 Mbps (30% - 50% reduction): SLOW (Orange)
  // - < 1.75 Mbps (> 50% reduction): POOR (Crimson)
  expectedSpeedMbps: 3.5,
  // Reduction > 30% and <= 50% from baseline speed is classified as SLOW
  slowReductionThresholdPercent: 30,
  // Reduction > 50% from baseline speed is classified as POOR
  poorReductionThresholdPercent: 50,
  // Round-trip latency > 800ms is classified as SLOW
  slowLatencyThresholdMs: 800,
  // Round-trip latency > 1800ms is classified as POOR
  poorLatencyThresholdMs: 1800,
  // Downlink bandwidth fallback threshold
  slowDownlinkThresholdMbps: 1.0,
  // 3-second grace period / hysteresis window to avoid jitter false alarms
  gracePeriodMs: 3000,
  // Minimum cooldown between repeated slow/poor warning notifications (25 seconds)
  notificationCooldownMs: 25000,
};

export const NETWORK_STATUS_MESSAGES = {
  ONLINE: "Connection is stable and good",
  SLOW: "Your internet connection is slow. Please check your network to avoid interruptions during the test.",
  POOR: "Your internet connection is poor! Significant speed reduction detected. Please check your connection.",
  OFFLINE: "Internet connection lost. Please reconnect to continue the test.",
  RESTORED: "Internet connection restored. You can continue your test.",
} as const;
